import React from 'react';
import { Table, Text } from '../../../app-components';
import { shorten } from '../../../Lib/helpers';
import { ROUTES } from '../../../Lib/constants';
import { getMailOfferListUri } from '../../../Queries/countUri';

const tableItems = {
  lg: {
    columns: [
      {
        header: 'By',
        width: 200,
        render: ({ item }) => (
          <Text style={{ fontSize: 17 }}>{shorten(item?.name, 12)}</Text>
        ),
      },
      {
        header: 'Name',
        type: 'text',
        width: 200,
        render: ({ item }) => (
          <Text style={{ fontSize: 17 }}>{shorten(item?.ar?.dms?.name)}</Text>
        ),
      },
      {
        header: 'Email#',
        type: 'text',
        width: 200,
        render: ({ item }) => (
          <Text style={{ fontSize: 17 }}>{shorten(item?.ar?.dms?.email)}</Text>
        ),
      },
      {
        header: 'Date Generated',
        type: 'date',
        field: 'onDate',
        width: 200,
      },
      {
        header: 'VIN',
        type: 'text',
        width: 200,
        render: ({ item }) => (
          <Text style={{ fontSize: 17 }}>
            {shorten(item?.ar?.dms?.vin, 20)}
          </Text>
        ),
      },
      {
        header: 'Year',
        type: 'text',
        field: 'ar.dms.year',
        width: 200,
      },
      {
        header: 'Make',
        type: 'text',
        field: 'ar.dms.make',
        width: 200,
      },
      {
        header: 'Model',
        type: 'text',
        field: 'ar.dms.model',
        width: 200,
      },
      {
        header: 'Mileage',
        type: 'text',
        field: 'ar.dms.mileage',
        width: 200,
      },
      // {
      //   header: 'Appraisal #',
      //   type: 'text',
      //   field: 'uci.repairOrderNumber',
      //   width: 200,
      // },

      {
        header: 'Range',
        type: 'text',
        width: 200,
        field: 'ar.finalRange',
      },
    ],
  },
};

export default Table({
  reloadEvent: ROUTES.WelcomeSA.name,
  uri: getMailOfferListUri,
  ...tableItems,
});
